import { render } from "./WaitListComplete.vue?vue&type=template&id=5a316ea1&scoped=true"
import script from "./WaitListComplete.vue?vue&type=script&lang=js"
export * from "./WaitListComplete.vue?vue&type=script&lang=js"

import "./WaitListComplete.vue?vue&type=style&index=0&id=5a316ea1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a316ea1"

export default script